import { formatCurrency } from '@fourthwall/utils/dist/currency';
import { isExcludedProductSelection } from './isExcludedProductSelection';
import { isSelectedProductSelection } from './isSelectedProductSelection';
export const mapDataToInitialValues = (data) => ({
    enabled: data.enabled,
    platform: data.platform || 'NOT_SELECTED',
    duration: data.durationSeconds || 60,
    productSelectionType: data.productSelection.type === 'EXCLUDED_PRODUCTS'
        ? 'ALL_PRODUCTS'
        : data.productSelection.type,
    includedProductsIds: isSelectedProductSelection(data.productSelection)
        ? data.productSelection.offerIds
        : [],
    excludedProductsIds: isExcludedProductSelection(data.productSelection)
        ? data.productSelection.offerIds
        : [],
    shippingChargeType: data.chargePolicy.shipping.type,
    shippingCharge: formatCurrency((data.chargePolicy.shipping.type === 'MAX_CREATOR' && data.chargePolicy.shipping.max) || 3),
});
